module.exports = __webpack_public_path__ + "img/jiantou.fec54102.png";